module.exports = "/assets/data/c5346d91268f18ca460dde9e85e9682c-N7.data.json";